import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route,useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Signup from './pages/Signup';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import PrivateRoute from "./components/PrivateRoute";
import Dashboard from './tutorpanel/Dashboard';
import Logout from './pages/Logout';
import ScrollToTop from './components/ScrollToTop';
import TutorLayout from './Layouts/TutorLayout';
import CourseCategories from './tutorpanel/CourseCategories';
import CourseCategoryForm from './tutorpanel/CourseCategoryForm';
import Courses from './tutorpanel/Courses';
import CourseForm from './tutorpanel/CourseForm';
import CourseChapterForm from './tutorpanel/CourseChapterForm';
import CourseDetails from './tutorpanel/CourseDetails';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
      // Check localStorage for token on mount
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token); // Set isLoggedIn based on token existence
  }, []);
  

  return (
    <Router>
      <ScrollToTop />
      <ConditionalLayout isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
    </Router>
  );
}

function ConditionalLayout({ isLoggedIn, setIsLoggedIn }) {
  const location = useLocation();

  // List of routes where the default Header/Footer should not appear
  const tutorRoutes = ["/manager"];
  const isTutorPage = tutorRoutes.some((route) => location.pathname.startsWith(route));

  return (
    <>
      {/* Conditionally render default Header and Footer */}
      {!isTutorPage && <Header isLoggedIn={isLoggedIn} />}
      <main>
        <Routes>
          {/* Public Routes */}
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about-us" element={<About />} />
          <Route exact path="/contact-us" element={<Contact />} />
          <Route exact path="/signup" element={<Signup />} />
          <Route exact path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/terms-conditions" element={<TermsConditions />} />
          <Route exact path="/logout" element={<Logout setIsLoggedIn={setIsLoggedIn} />} />

          {/* Protected Routes */}
          <Route
    path="/manager/*"
    element={
      <PrivateRoute>
        <TutorLayout />
      </PrivateRoute>
    }
    >
    <Route path="dashboard" element={<Dashboard />} />
    <Route path="course-categories" element={<CourseCategories />} />
    <Route path="course-category/add" element={<CourseCategoryForm />} />
    <Route path="courses" element={<Courses />} />
    <Route path="course/add" element={<CourseForm />} />
    <Route path="course-chapter" element={<CourseChapterForm />} />
    <Route path="course-details" element={<CourseDetails />} />
          </Route>
        </Routes>
      </main>
      {!isTutorPage && <Footer />}
    </>
  );
}
export default App;